/**
 * Validates that at least one of the given values is present.
 */
export const Validator = {
    name: "some_in",
    errorMessage: "some_in validation failed",
    validate: (value, requirement) => {
        if (typeof value !== "string") {
            return false;
        }
        const acceptedValues = requirement.split(",");
        return value.split(":").some(v => acceptedValues.includes(v));
    },
};
